import { useState, useContext } from "react";
import { AuthContext } from "../Context/AuthContext";
import { useCustomerFormContext } from "../Context/CustomerFormContext";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "react-query";

const defaultForm = {
  state: "",
  city: "",
  country: "",
  address: "",
};

const useForm = () => {
  const { formDatas } = useCustomerFormContext();
  const { token} = useContext(AuthContext);
  const queryClient = useQueryClient();
  const [formData, setFormData] = useState({
    ...defaultForm,
    country: formDatas.selectedCountry || "Nigeria"
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      const requestData = {
        companyName: formDatas.companyName,
        registrationNumber: formDatas.registrationNumber,
        address: formData.address,
        state: formData.state,
        city: formData.city,
        country: formData.country,
        phoneNumber: formDatas.phoneNumber,
        additionalPhoneNumber: formDatas.additionalPhoneNumber,
        yearsInOperation: parseInt(formDatas.yearsInOperation), 
        fundingSource: formDatas.fundingSource,
        website: formDatas.website,
        isProfileVerified: true,
        profileComplete: true,
        createdProfileStepStatus: { status: "completed" }
      };

      console.log(requestData)
  
      const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/charterer/profile`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData), 
      });
  
      const resData = await res.json();
  
      if (!res.ok) {
        throw new Error(resData.message);
      }
  
      setLoading(false);
      setSuccess("Profile updated successfully");
      // Invalidate profile query to refresh profile data
      queryClient.invalidateQueries(["profile"]);
      setTimeout(() => {
        setSuccess(null);
        navigate("/statutorydocs");
      }, 3000);
    } catch (error) {
      setError(error.message);
      setLoading(false);
    }
  };
  

  return {
    handleChange,
    handleSubmit,
    loading,
    formData,
    error,
    success,
  };
};

export default useForm;
